import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import {
  VueAxios
} from './axios'
import notification from 'ant-design-vue/es/notification'
import message from 'ant-design-vue/es/message'
import {
  ACCESS_TOKEN
} from '@/store/mutation-types'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/rest-api', // 'http://localhost:9090/rest-api', // api base_url
  timeout: 60 * 1000 * 5 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    /* const token = Vue.ls.get(ACCESS_TOKEN) */
    if (error.response.status === 401) {
      notification.error({
        message: 'Unauthorized',
        description: '无法验证身份, 本次登录已过期' // Authorization verification failed
      })
      // if (token) {
      //   store.dispatch('Logout').then(() => {
      //     setTimeout(() => {
      //       window.location.reload()
      //     }, 1500)
      //   })
      // }
    } else {
      let msg = data.message
      if (msg && msg.length > 50) {
        msg = msg.substring(0, 50) + '...'
      }
      if (error.response.status === 403) {
        notification.error({
          message: 'Forbidden',
          description: msg
        })
      } else {
        /*
        notification.error({
          message: '请求失败',
          description: msg
        }) */
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  const res = response.data
  const contentType = response.headers['content-type'] || ''
  if (contentType.includes('application/octet-stream') ||
      contentType.includes('application/pdf') ||
      contentType.includes('image/') ||
      response.config.responseType === 'blob') {
    return response
  }
  if (res.code === 1) {
    return res
  } else {
    // message.error(res.msg + ' ' + res.data)
    // return Promise.reject(response)
    if (res.code === 401) {
      store.dispatch('Logout').then(() => {
        setTimeout(() => {
          window.location.reload()
        }, 1500)
      })
    } else {
      message.error(res.msg + ' ' + (res.data || ''))
      return Promise.reject(response)
    }
  }
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
